import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'WatchCategory';

const WatchCategoryApi: any = baseApi(endpoint);

export default WatchCategoryApi;